import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImSpinner8 } from 'react-icons/im';

const LoadingRoute = () => {

    const { t } = useTranslation();

    return (
        <div className="w-full h-full min-h-dvh flex items-center justify-center">
            <div className='flex items-center gap-1'><ImSpinner8 className="animate-spin" /><span>{t('products.main_loading')}</span></div>
        </div>
    );
};

export default LoadingRoute;
